module.exports = __webpack_public_path__ + "img/victor-3.9e64ce34.png";